import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Undo2, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, fmtDate } from "@/lib/api";

export default function Imports() {
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  const load = () => api.get("/imports").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const undo = async (i) => {
    if (!window.confirm(`Undo "${i.filename}"? This permanently deletes all ${i.remaining} lead(s) from this upload, including their activity, campaign enrollments and queued Outbox emails.`)) return;
    try { const { data } = await api.delete(`/imports/${i.id}`); toast.success(`Deleted ${data.deleted} lead(s)`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader eyebrow="Leads" title="Import history" />
      <div className="p-6 lg:p-10">
        <div className="bg-white border rounded-xl overflow-x-auto">
          <table className="w-full text-sm" data-testid="imports-table">
            <thead><tr className="border-b bg-slate-50 text-left">{["Uploaded", "File", "By", "Imported", "No email", "Duplicates", "Still in CRM", ""].map((h, i) => <th key={i} className="p-3 label-xs font-semibold">{h}</th>)}</tr></thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} className="border-b last:border-0" data-testid={`import-row-${i.id}`}>
                  <td className="p-3 text-xs">{fmtDate(i.created_at)}</td>
                  <td className="p-3 font-medium">{i.filename}{i.status === "undone" && <span className="ml-2 text-[10px] bg-slate-200 rounded px-1.5">undone</span>}</td>
                  <td className="p-3 text-xs">{i.user_name}</td>
                  <td className="p-3 font-mono">{i.created}</td>
                  <td className="p-3 font-mono">{i.no_email || 0}</td>
                  <td className="p-3 font-mono">{i.duplicates || 0}</td>
                  <td className="p-3 font-mono" data-testid={`import-remaining-${i.id}`}>{i.remaining}</td>
                  <td className="p-3 text-right whitespace-nowrap">
                    {i.remaining > 0 && <Button size="sm" variant="ghost" asChild data-testid={`import-view-${i.id}`}><Link to={`/leads?import=${i.id}`}><Eye size={14} className="mr-1" />View leads</Link></Button>}
                    {user?.role === "admin" && i.remaining > 0 && <Button size="sm" variant="outline" className="border-red-300 text-red-700 hover:bg-red-50" onClick={() => undo(i)} data-testid={`import-undo-${i.id}`}><Undo2 size={14} className="mr-1" />Undo import</Button>}
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={8} className="p-10 text-center text-slate-500" data-testid="imports-empty">No imports yet. Imports made from now on are listed here.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
